import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ApplicationType } from 'enums/ApplicationType';
import { ContractorNameSource } from 'enums/ApplicationsVariables';

export interface SalespersonInfo {
  name: string;
  email?: string;
  phone?: string;
}

export interface DataState {
  applicationType: ApplicationType | null;
  contractorName: string;
  salesPerson: string;
  salespersonData: Record<string, SalespersonInfo>;
  network: string | null;
  device: string | null;
  promoCode: string;
  refer: string | null;
  sourcename: string | null;
  sourcetype: string | null;
  howDidYouHearAboutUs: string | null;
  howDidYouHearAboutUsComment: string | null;
  isIframe?: boolean;
  contractorAutofillUsed?: ContractorNameSource | null;
  campaignId: string | null;
  adGroupId: string | null;
  utmSource: string | null;
  utmMedium: string | null;
  utmCampaign: string | null;
  utmTerm: string | null;
  utmContent: string | null;
  gclid: string | null;
  fbclid: string | null;
  liFatId: string | null;
  pintrestEpik: string | null;
  uetMsclkId: string | null;
  contractorId: string;
  jobTreadContractorUuid: string | null;
  jobTreadDocumentId: string | null;
  jobTreadContractorName: string | null;
  jobTreadLoanAmount: string | null;
}

const initialState: DataState = {
  applicationType: null,
  contractorName: '',
  contractorId: '',
  salesPerson: '',
  salespersonData: {},
  network: '',
  device: '',
  promoCode: '',
  refer: '',
  sourcename: '',
  sourcetype: '',
  howDidYouHearAboutUs: '',
  howDidYouHearAboutUsComment: '',
  isIframe: false,
  campaignId: '',
  adGroupId: '',
  utmSource: '',
  utmMedium: '',
  utmCampaign: '',
  utmTerm: '',
  utmContent: '',
  gclid: '',
  fbclid: '',
  liFatId: '',
  pintrestEpik: '',
  uetMsclkId: '',
  jobTreadContractorUuid: '',
  jobTreadDocumentId: '',
  jobTreadContractorName: '',
  jobTreadLoanAmount: '',
};

const data = createSlice({
  name: 'data',
  initialState: initialState,
  reducers: {
    setData: (state: DataState, { payload }: PayloadAction<Partial<DataState>>) => {
      Object.assign(state, payload);
    },
  },
});

export const { setData } = data.actions;

export default data.reducer;
